import React, { useState } from "react";
import { FaEnvelope, FaNewspaper, FaLightbulb, FaBell } from "react-icons/fa6";
import { Container, GradientButton, H2_SIZE } from "./ui";

const MAILER_URL = "https://mailer.datametricks.com/send-email.php";

const perks = [
  { icon: FaNewspaper, label: "Latest insights", tone: "bg-blue-50 text-blue-600" },
  { icon: FaLightbulb, label: "Practical ideas", tone: "bg-violet-50 text-violet-600" },
  { icon: FaBell, label: "No spam, only value", tone: "bg-emerald-50 text-emerald-600" },
];

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ loading: false, msg: "", ok: false });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setState({ loading: false, msg: "Please enter a valid email address.", ok: false });
      return;
    }
    setState({ loading: true, msg: "", ok: false });
    try {
      const res = await fetch(MAILER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: "Newsletter Subscriber", email, phone: "N/A", message: "Newsletter subscription request from the home page." }),
      });
      const result = await res.json();
      const ok = result.status === "success";
      setState({ loading: false, ok, msg: ok ? "Thanks for subscribing!" : result.message || "Something went wrong." });
      if (ok) setEmail("");
    } catch (err) {
      setState({ loading: false, ok: false, msg: "Error subscribing. Please try again." });
    }
  };

  return (
    <section className="bg-white pb-[32px] lg:pb-[46px]">
      <Container>
        <div className="grid items-center gap-8 rounded-[28px] bg-gradient-to-br from-[#F7F9FF] to-white p-[24px] shadow-card ring-1 ring-blue-100 sm:p-[36px] lg:grid-cols-[1fr_1.25fr]">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-brand-soft px-[12px] py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-brand-blue">
              <FaEnvelope /> Newsletter
            </span>
            <h2 className={`mt-[14px] font-extrabold tracking-tight text-ink ${H2_SIZE}`}>
              Insights for Your
              {" "}<br />
              <span className="text-gradient">Digital Growth</span>
            </h2>
            <p className="mt-2 text-[15px] text-slate-500">Subscribe for useful tips, ideas, and updates from our team.</p>
          </div>

          <div>
            <form onSubmit={onSubmit} noValidate className="flex flex-col gap-[12px] sm:flex-row">
              <div className="relative flex-1">
                <FaEnvelope className="absolute left-[16px] top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  aria-label="Email address"
                  className="w-full rounded-xl border-[1px] border-solid border-blue-100 bg-white py-[15px] pl-[44px] pr-[16px] text-[15px] text-ink outline-none transition placeholder:text-slate-400 focus:border-brand-blue focus:ring-4 focus:ring-blue-100"
                />
              </div>
              <GradientButton type="submit" disabled={state.loading} className="rounded-xl">
                {state.loading ? "Subscribing..." : "Subscribe"}
              </GradientButton>
            </form>
            {state.msg && <p className={`mt-2 text-[13px] ${state.ok ? "text-emerald-600" : "text-rose-500"}`}>{state.msg}</p>}
            <div className="mt-[20px] flex flex-wrap gap-y-[12px]">
              {perks.map((p, i) => (
                <div key={p.label} className={`flex items-center gap-2.5 pr-[20px] ${i > 0 ? "border-l border-slate-200 pl-[20px]" : ""}`}>
                  <span className={`inline-flex h-[38px] w-[38px] items-center justify-center rounded-full text-[15px] ${p.tone}`}>
                    <p.icon />
                  </span>
                  <span className="text-[14px] text-slate-600">{p.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Newsletter;
